import { CreditCard, Ship } from 'lucide-react'
import { useState } from 'react'

import { isApproverOrHigherRole } from '@ankor-io/common/domain/iam/account'

import { useUserContext } from '@/providers/user/useUserContext'
import { Button } from '@/ui-components/Button'
import IssueCardModal from '@/views/components/IssueCardModal'

export const QuickActionsBar = () => {
  const { activeOrganizationRole } = useUserContext()

  const [isIssueCardModalOpen, setIsIssueCardModalOpen] = useState(false)

  return (
    <div className="flex flex-wrap gap-3 p-4 rounded-lg bg-gradient-to-r from-primary-50 to-indigo-50 dark:from-primary-900 dark:to-indigo-900 border-primary-200 dark:border-primary-800">
      {isApproverOrHigherRole(activeOrganizationRole) && (
        <Button
          color="dark/white"
          to="/charters/new"
        >
          <Ship data-slot="icon" />
          Create New Charter
        </Button>
      )}
      <Button
        outline
        onClick={() => setIsIssueCardModalOpen(true)}
      >
        <CreditCard data-slot="icon" />
        Issue Virtual Card
      </Button>

      <IssueCardModal
        isOpen={isIssueCardModalOpen}
        onClose={() => setIsIssueCardModalOpen(false)}
      />
    </div>
  )
}

export default QuickActionsBar
